
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'fire-live-tracker-icon',
  props: {
    liveTracker: Boolean,
  },
});
